












































import { IContent } from "@/models/Content.model";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class DatesForm extends Vue {
  get dates() {
    return this.$store.getters.getDatesContent;
  }

  content: IContent = {};
  fixedString = "";

  update() {
    if (this.content.text) {
      this.fixedString = this.content.text.replace(/(?:\r\n|\r|\n)/g, "<br>");
    }
    this.content.text = this.fixedString;
    this.$emit("update", this.content);
  }

  addDate() {
    if (this.content.dates && this.content.dates.length > 0) {
      this.content.dates.push({
        _id: `${this.content.dates.length + 1}`,
        date: "",
        title: "",
      });
    } else {
      this.content.dates = [
        // @ts-ignore
        { _id: `${this.content.dates.length + 1}`, date: "", title: "" },
      ];
    }
  }

  removeDate(id?: string) {
    console.log(id);
    if (!this.content.dates) return;
    const filteredDates = this.content.dates.filter((date) => date._id != id);
    this.content.dates = filteredDates;
  }

  mounted() {
    this.content = Object.assign({}, this.dates);
  }

  cancel() {
    this.content.dates = Object.assign({}, this.dates);
  }
}
